export default __webpack_public_path__ + "static/media/chevron-down.980114ef.svg";